import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrButton from '@components/BrButton';
import BrIcons from '@components/BrIcons';
import BrText from '@components/BrText';
import ColorStyles from '@components/ColorStyles';
import './brDropdownMenuButton.scss';

/* eslint-disable react/no-array-index-key */
export default class BrDropdownMenuButton extends PureComponent {
  static propTypes = {
    btnColorStyle: PropTypes.oneOf(Object.values(ColorStyles)),
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isReturnWholeItem: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.element,
        isHeader: PropTypes.bool,
        title: PropTypes.string,
        value: PropTypes.any,
        dom: PropTypes.node,
      }),
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
    title: PropTypes.any.isRequired,
  };

  static defaultProps = {
    btnColorStyle: ColorStyles.GRAY,
    isReturnWholeItem: false,
    isDisabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    }; // may use initial props
  }

  handleSelectItem = (item) => {
    const { onSelect, isReturnWholeItem } = this.props;
    if (onSelect) {
      onSelect(item.value !== undefined && !isReturnWholeItem ? item.value : item);
    }
    this.setState({ isActive: false });
  };

  handleBlur = () => {
    this.setState({ isActive: false });
  };

  handleClickBtn = () => {
    if (!this.props.isDisabled) {
      this.setState({ isActive: !this.state.isActive });
    }
  };

  renderDisplayTitle = (item) => {
    return (
      <div className={cn('item-title', { disabled: this.props.isDisabled })}>
        {item.icon}
        <div>
          <BrText>{item.title || item.value}</BrText>
        </div>
        {item.dom}
      </div>
    );
  };

  render() {
    const { title, items, className, btnColorStyle, isDisabled } = this.props;
    const { isActive } = this.state;
    const classname = cn('br-dropdown-menu-button', className, {
      active: isActive,
      disabled: isDisabled,
    });

    const btnTitle = (
      <div className="dropdown-title" title={title}>
        <BrIcons.Include isSubComp colorStyle={btnColorStyle} disableHover />
        <div className="dropdown-title-text">
          <BrText>{title}</BrText>
        </div>
        <BrIcons.DownCaret className="down-caret" isSubComp colorStyle={btnColorStyle} disableHover />
      </div>
    );

    return (
      <div className={classname} tabIndex="0" onBlur={this.handleBlur} data-id="br-dropdown-menu-button">
        <BrButton
          title={btnTitle}
          onClick={this.handleClickBtn}
          isSubComp
          noEdge
          colorStyle={btnColorStyle}
          isDisabled={isDisabled}
        />
        <div className="dropdown-item-list">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="dropdown-item"
              onClick={() => this.handleSelectItem(item)}
              title={item.title || item.value}
            >
              {this.renderDisplayTitle(item)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
